import { BPA_SEVERITY_CONFIG } from './config';
import { BPAHistoryEvent } from '../types';
import { AGE_BANDS, AgeBandKey } from '../VulnMetrics/types';

interface BPADrillDownScope {
  severity: number[];
  provider: string[];
  integrationIds: number[];
}

interface BPADrillDownOptions extends BPADrillDownScope {
  historyType?: BPAHistoryEvent;
  historyStartAt?: string;
  effectiveStatus?: string;
  severityOverride?: number;
  providerOverride?: string;
  controlId?: number;
  benchmark?: string;
  ageBand?: AgeBandKey;
}

const appendScope = (params: URLSearchParams, options: BPADrillDownScope) => {
  const allSeveritiesSelected = BPA_SEVERITY_CONFIG.every((severity) =>
    options.severity.includes(severity.value),
  );
  if (options.severity.length > 0 && !allSeveritiesSelected) {
    params.set('severity', options.severity.join(','));
  }
  if (options.provider.length > 0) {
    params.set('provider', options.provider.join(','));
  }
  if (options.integrationIds.length > 0) {
    params.set('integration', options.integrationIds.join(','));
  }
};

export const buildBPAFindingsDrillDownUrl = (
  options: BPADrillDownOptions,
): string => {
  const params = new URLSearchParams();
  appendScope(params, {
    ...options,
    severity:
      options.severityOverride !== undefined
        ? [options.severityOverride]
        : options.severity,
    provider: options.providerOverride
      ? [options.providerOverride]
      : options.provider,
  });

  if (options.historyType && options.historyStartAt) {
    const dateFilterByHistoryType: Record<BPAHistoryEvent, string> = {
      new: 'first_seen_at',
      fixed: 'last_fixed_at',
      ignored: 'ignored_date',
    };
    params.set(
      `dt_filter__${dateFilterByHistoryType[options.historyType]}__from`,
      String(new Date(options.historyStartAt).getTime()),
    );
  }

  if (options.effectiveStatus === 'Ignored') {
    params.set('user_status', 'Ignored');
  } else if (options.effectiveStatus) {
    params.set('scan_status', options.effectiveStatus);
  }

  if (options.controlId !== undefined) {
    params.set('control_id', options.controlId.toString());
  }
  if (options.benchmark) {
    params.set('benchmark', options.benchmark);
  }

  if (options.ageBand) {
    const band = AGE_BANDS.find(({ key }) => key === options.ageBand);
    if (band && 'min' in band)
      params.set('age_min_exclusive', String(band.min));
    if (band && 'max' in band) params.set('age_max', String(band.max));
  }

  return `bpa-findings?${params.toString()}`;
};
